import { FormControl, FormControlLabel, InputAdornment, InputLabel, LinearProgress, MenuItem, Paper, Radio, Select, TextField, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { format, parse } from 'date-fns';
import React from 'react';
import AssistenciaOdontoService from '../../services/AssistenciaOdontoService';
import ProcessoService from '../../services/ProcessoService';
import ReembolsoMedicoService from '../../services/ReembolsoMedicoService';
import FilterBeneficiario from '../share/FilterBeneficiario';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import Utils from '../share/Utils';
import VariantSnackbar from '../share/VariantSnackbar';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  radioCnpj: {
    marginLeft: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 0.5,
  },
  radioCpf: {
    marginBottom: theme.spacing.unit * 0.5,
  },
  typographyTituloPaper: {
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    color: theme.palette.text.secondary,
    fontSize: 13
  },
  textFieldNomePrestador: {
    width: 480,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  textFieldCpfCnpj: {
    width: 180,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControlAutoCompletePrestador: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    minWidth: 750,
  },
  formControlAutoCompleteBenef: {
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 2,
    minWidth: 400,
  },
  formControlValor: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 280,
  },
  textFieldDtaNf: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 232,
    marginRight: theme.spacing.unit,
  },
  selectAnoProcesso: {
    width: 180,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
  },
  textFieldNumProcesso: {
    width: 180,
    marginLeft: theme.spacing.unit,
    margin: theme.spacing.unit,
  },
  formControlObservacao: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 830,
  },
  formControlValorInfo: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 255,
  },
  checkBox: {
    marginLeft: theme.spacing.unit,
  },
  textFieldTxtCodigoSei: {
    width: 180,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});
class FormDialogReembolsoMedico extends React.Component {
  utils = new Utils();
  assistenciaOdontoService = new AssistenciaOdontoService();
  processoService = new ProcessoService();
  reembolsoService = new ReembolsoMedicoService();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.reembolso,
      fetching: false,
      fetchingProcessos: false,
      nomesBeneficiarios: this.props.nomesBeneficiarios,
      prestadores: this.props.prestadores,
      processos: [],
      fetchingNomePrestador: false,
      valueRadio: 'CNPJ',
      snackOpen: false,
      snackMessage: '',
      sucesso: false,
      errorMessageValorNf: '',
      errorMessageValorReembolso: '',
      errorMessageNumNf: '',
      errorMessageNumSerieNf: '',
      errorMessageData: '',
      errorMessageCpfCnpj: '',
      errorMessageNomePrestador: '',
    };
    this.state.dtaNf = format(parse(this.state.dtaNf), 'YYYY-MM-DD');
    this.state.valNf = this.state.valNf === undefined ? '' : this.state.valNf;
    this.state.valReembolso = this.state.valReembolso === undefined ? '' : this.state.valReembolso;
    this.state.valDeducao = this.state.valDeducao === undefined ? '' : this.state.valDeducao;
    if (this.state.numCpfCgc !== undefined) {
      if (this.state.numCpfCgc.toString().length === 11) {
        this.state.numCpfCgc = this.utils.formatCPFTextField(this.state.numCpfCgc.toString(), '');
        this.state.valueRadio = 'CPF';
        
      } else {
        this.state.numCpfCgc = this.utils.formatCNPJTextField(this.state.numCpfCgc.toString(), '');
        this.state.valueRadio = 'CNPJ';
      }
    }    
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  handleClickLimpar = async () => {
    this.setState({
      numMatricula: '',
      nomeBeneficiario: ''
    });
  }
  consultarNomePrestador = async () => {    
    if (this.state.numCpfCgc !== undefined &&
        this.state.numCpfCgc !== '' &&
        (this.state.numCpfCgc.replace(/[^0-9]/g, '').length === 11 || this.state.numCpfCgc.replace(/[^0-9]/g, '').length === 14)) {
      let prestador = await this.reembolsoService.consultarNomePrestador(Number(this.state.numCpfCgc.replace(/[^0-9]/g, '')));
      let nomPrestador = prestador.nome;
      let seqPrestador = prestador.id;
      if (nomPrestador === '') {
        let nomePrestadorJson = await this.assistenciaOdontoService.consultarNomeDentistaReceita(this.state.numCpfCgc.replace(/[^0-9]/g, ''));
        nomPrestador = nomePrestadorJson.nome
      }    
      this.setState({seqPrestador: seqPrestador, nomPrestador: nomPrestador, errorMessageNomePrestador: nomPrestador === '' ? 'O CPF/CNPJ não foi encontrado na base da Receita Federal' : ''});  
    } else {
      this.setState({seqPrestador: 0, nomPrestador: '', numCpfCgc: '', errorMessageNomePrestador: ''});  
    }
  }

  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({
      numMatricula: carteira,
      nomeBeneficiario: nome
    });
  }
  handleBlurValor = event => {
    if (event.target.name === 'valNf'){
      if (this.state.valNf === '' || this.state.valNf === null || this.state.valNf === undefined) {
        this.setState({errorMessageValorNf: 'Este campo é obrigatório'});
      } else {
        this.setState({errorMessageValorNf: ''});
      }
      // if (this.state.valNf !== '' && this.state.valNf !== null && this.state.valNf !== undefined &&
      //     this.state.valReembolso !== '' && this.state.valReembolso !== null && this.state.valReembolso !== undefined &&
      //     Number(this.state.valNf.replace('.', '').replace('.', '').replace(',', '.')) < Number(this.state.valReembolso.replace('.', '').replace('.', '').replace(',', '.'))) {
      //       this.setState({errorMessageValorNf: 'Valor Nf menor que Valor Reembolso'});
      // } else {
      //   this.setState({errorMessageValorNf: ''});
      // }
    }
    if (event.target.name === 'valReembolso') {
      if (this.state.valReembolso === '' || this.state.valReembolso === null || this.state.valReembolso === undefined) {
        this.setState({errorMessageValorReembolso: 'Este campo é obrigatório'});
      } else {
        this.setState({errorMessageValorReembolso: ''});
      }
      // if (this.state.valNf !== '' && this.state.valNf !== null && this.state.valNf !== undefined &&
      //     this.state.valReembolso !== '' && this.state.valReembolso !== null && this.state.valReembolso !== undefined &&
      //     Number(this.state.valNf.replace('.', '').replace('.', '').replace(',', '.')) < Number(this.state.valReembolso.replace('.', '').replace('.', '').replace(',', '.'))) {
      //       this.setState({errorMessageValorNf: 'Valor Nf menor que Valor Reembolso'});
      // } else {
      //   this.setState({errorMessageValorNf: ''});          
      // }
    }
    if ((this.state.numNf === '' || this.state.numNf === null || this.state.numNf === undefined) && (event.target.name === 'numNf')) {
      this.setState({errorMessageNumNf: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageNumNf: ''});
    }
  }
  handleChangeRadio = event => {
    this.setState({ valueRadio: event.target.value, numCpfCgc: '', nomPrestador: '', errorMessageCpfCnpj: '', errorMessageNomePrestador: '', fetchingNomePrestador: false });
  };

  handleBlurData = event => {
    if (this.state.dtaNf === null ||
      this.state.dtaNf === undefined ||
      this.state.dtaNf === '') {
      this.setState({errorMessageData: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageData: ''});
    }
  }
  handleChangeTextCpfCnpj = event => {
    var novoValor = event.target.value;
    if (this.state.valueRadio === 'CNPJ') {
      novoValor = this.utils.formatCNPJTextField(novoValor, event.target.defaultValue);
    } else {
      novoValor = this.utils.formatCPFTextField(novoValor, event.target.defaultValue);
    }
    this.setState({ [event.target.name]: novoValor });
  };
  handleBlurCpfCnpj = async event => {
    this.setState({fetchingNomePrestador: true});
    await this.consultarNomePrestador();
    this.setState({fetchingNomePrestador: false});
  }

  handleChangeTextField = event => {
    var valorNovo = '';
    if (event.target.name === 'valNf') {
      valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValorNf: '' });
    }
    if (event.target.name === 'valReembolso') {
      valorNovo = event.target.value !== '' ? this.utils.formataValorNegativo(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValorReembolso: '' });
    }
    if (event.target.name === 'valDeducao') {
      valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo});
    }
    if (event.target.name === 'numNf') {
      valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 8);
      this.setState({ [event.target.name]: valorNovo, errorMessageNumNf: '' });
    }
    if (event.target.name === 'numSerieNf') {
      valorNovo = event.target.value.toUpperCase().substring(0, 6);
      this.setState({ [event.target.name]: valorNovo, errorMessageNumSerieNf: '' });
    }
    if (event.target.name === 'txtProcessoSei' || event.target.name === 'txtObservacao') {
      valorNovo = event.target.value.toUpperCase();
      this.setState({ [event.target.name]: valorNovo});
    }    
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeSelectAnoProcesso = async event => {
    this.setState({fetchingProcessos: true, numProcesso: ''});
    if (event.target.value !== 0) {
      let processos = await this.processoService.consultarProcessos(event.target.value);
      this.setState({ processos: processos });
    } else {
      await this.processoService.consultarAnosProcessos();
    }
    this.setState({anoProcesso: event.target.value, fetchingProcessos: false});
  }
  getSuggestionValueNumProcesso = (suggestion, id, a) => {
    if (suggestion.nome !== undefined) {
      this.setState({numProcesso: Number(suggestion.nome)});
    }
    if (suggestion === '' && id === 0) {
      this.setState({numProcesso: undefined});
    }
    return suggestion.nome;
  }
  handleChangeCheckBox = event => {
    if (this.state.indAcerto === 'S') {
      this.setState({ indAcerto: 'N',  });
    } else {
      this.setState({ indAcerto: 'S' });
    }
    
  }

  isSalvarDisabled = () => {
    return (this.state.errorMessageValorReembolso !== '' ||
    this.state.valReembolso === undefined ||
    this.state.valReembolso === 0 ||
    this.state.valReembolso === '') ||

    (this.state.errorMessageValorNf !== '' ||
    this.state.valNf === undefined ||
    this.state.valNf === 0 ||
    this.state.valNf === '') ||

    (this.state.errorMessageNumNf !== '' ||
    this.state.numNf === undefined ||
    this.state.numNf === 0 ||
    this.state.numNf === '') ||

    (this.state.errorMessageData !== '' ||
     this.state.dtaNf === undefined ||
     this.state.dtaNf === 'Invalid Date' ||
     this.state.dtaNf === '') ||

    (this.state.nomeBeneficiario === '' ||
     this.state.nomeBeneficiario === undefined) ||

     (this.state.errorMessageNomePrestador !== '' ||
     this.state.nomPrestador === '' ||
     this.state.nomPrestador === undefined);
  }

  handleClickSave = async () => {
    const reembolso = {
      numProtocolo: this.state.numProtocolo === undefined ? 0 : this.state.numProtocolo,
      seqBeneficiario: this.state.seqBeneficiario === undefined ? 0 : this.state.seqBeneficiario,
      seqDependente: this.state.seqDependente === undefined ? 0 : this.state.seqDependente,
      numMatricula: this.state.numMatricula,
      nomeBeneficiario: '',
      seqPrestador: this.state.seqPrestador,
      nomPrestador: this.state.nomPrestador,
      numProcesso: this.state.numProcesso === undefined ? 0 : this.state.numProcesso,
      anoProcesso: this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso,
      numNf: this.state.numNf,
      numSerieNf: this.state.numSerieNf === undefined || this.state.numSerieNf === '' ? 0 : this.state.numSerieNf,
      dtaNf: this.state.dtaNf === undefined ? null : this.state.dtaNf,
      valNf: this.state.valNf > 0 ? this.state.valNf.replace('.', '').replace('.', '').replace(',', '.') : this.state.valNf.replace('.', '').replace('.', '').replace(',', '.'),
      valReembolso: this.state.valReembolso > 0 ? this.state.valReembolso.replace('.', '').replace('.', '').replace(',', '.') : this.state.valReembolso.replace('.', '').replace('.', '').replace(',', '.'),
      valDeducao: this.state.valDeducao === '' ? 0 : this.state.valDeducao > 0 ? this.state.valDeducao.replace('.', '').replace('.', '').replace(',', '.') : this.state.valDeducao.replace('.', '').replace('.', '').replace(',', '.'),
      txtObservacao: this.state.txtObservacao === undefined || this.state.txtObservacao === '' ? '-' : this.state.txtObservacao,
      codUsuarioCadastro: '',
      dtaCadastro: null,
      anoPag: null,
      mesPag: null,
      codTipoPag: null,
      indAcerto: this.state.indAcerto === undefined ? 'N' : this.state.indAcerto,
      codEstado: null,
      desEstado: null,
      seqRubrica: null,          
      txtProcessoSei: this.state.txtProcessoSei === undefined || this.state.txtProcessoSei === null ? '' : this.state.txtProcessoSei,
      numCpfCgc: Number(this.state.numCpfCgc.replace('.', '').replace('.', '').replace('-', '').replace('/', '')),
    };
    await this.props.handleSave(reembolso);
  }
  render () {
    const { classes, open, handleClose, titulo, prestadores } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <Paper className={classes.body} elevation={1}>
                <Typography className={classes.typographyTituloPaper}>
                  Dados do Beneficiário
                </Typography>
                <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
                  <FilterBeneficiario
                    beneficiarios={this.props.nomesBeneficiarios}
                    disabled={!this.props.isEditavel}
                    nomeInicial={this.state.nomeBeneficiario}
                    carteiraInicial={this.state.numMatricula}
                    handleSelectBeneficiario={this.handleSelectBeneficiario}
                    handleClickLimpar={this.handleClickLimpar}
                    maxSuggestions={10} />
                </FormControl>
              </Paper>
              <Paper className={classes.body} elevation={1}>
              <Typography className={classes.typographyTituloPaper}>
                Dados do Prestador
              </Typography>
              <FormControlLabel
                  label='CNPJ'
                  disabled={!this.props.isEditavel}
                  className={classes.radioCnpj}
                  control={<Radio
                    checked={this.state.valueRadio === 'CNPJ'}
                    aria-label='CNPJ'
                    onChange={this.handleChangeRadio}
                    value='CNPJ'
                    name='radio-CNPJ' />}
                />
                <FormControlLabel
                  label='CPF'
                  disabled={!this.props.isEditavel}
                  className={classes.radioCpf}
                  control={<Radio
                    checked={this.state.valueRadio === 'CPF'}
                    aria-label='CPF'
                    onChange={this.handleChangeRadio}
                    value='CPF'
                    name='radio-CPF' />}
                />
                <FormControl>
                  <TextField
                    error={this.state.errorMessageCpfCnpj !== ''}
                    margin='dense'
                    disabled={!this.props.isEditavel}
                    className={classes.textFieldCpfCnpj}
                    name='numCpfCgc'
                    label={this.state.errorMessageCpfCnpj !== '' ? this.state.errorMessageCpfCnpj : 'CPF/CNPJ'}
                    fullWidth
                    value={this.state.numCpfCgc}
                    onChange={this.handleChangeTextCpfCnpj}
                    onBlur={this.handleBlurCpfCnpj}
                    />                
                </FormControl>
                <FormControl className={classes.textFieldNomePrestador}>
                  {this.state.fetchingNomePrestador ? <LinearProgress color='primary'/>
                  : <TextField
                    disabled
                    error={this.state.errorMessageNomePrestador !== ''}
                    margin='dense'
                    name='nomPrestador'
                    label={this.state.errorMessageNomePrestador !== '' ? this.state.errorMessageNomePrestador : 'Prestador'}
                    fullWidth
                    value={this.state.nomPrestador}/>
                }
                </FormControl>
              </Paper>
              <Paper className={classes.body} elevation={1}>
                <FormControl>
                  <TextField
                    id='date'
                    disabled={!this.props.isEditavel}
                    error={this.state.errorMessageData !== ''}
                    label={this.state.errorMessageData !== '' ? this.state.errorMessageData : 'Data da Nf'}
                    type='date'
                    value={this.state.dtaNf}
                    onChange={this.handleChange}
                    onBlur={this.handleBlurData}
                    inputProps={{
                      name: 'dtaNf',
                    }}
                    className={classes.textFieldDtaNf}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControlValor}>
                  <TextField
                    value={this.state.numNf === null || this.state.numNf === undefined ? '' : this.state.numNf}
                    disabled={!this.props.isEditavel}
                    margin='dense'
                    id='numNf'
                    name='numNf'
                    style={{maxlength: '7'}}
                    error={this.state.errorMessageNumNf !== ''}
                    label={this.state.errorMessageNumNf !== '' ? this.state.errorMessageNumNf : 'Número da Nota'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValor}
                  />
                </FormControl>
                <FormControl className={classes.formControlValor}>
                  <TextField
                    value={this.state.numSerieNf === null || this.state.numSerieNf === undefined ? '' : this.state.numSerieNf}
                    disabled={!this.props.isEditavel}
                    style={{display: 'none'}}
                    margin='dense'
                    id='numSerieNf'
                    name='numSerieNf'
                    error={this.state.errorMessageNumSerieNf !== ''}
                    label={this.state.errorMessageNumSerieNf !== '' ? this.state.errorMessageNumSerieNf : 'Num. Série da Nf'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValor}
                  />
                </FormControl>
                <FormControl className={classes.formControlValor}>
                  <TextField
                    value={this.state.valNf === null ? '0,00' : this.utils.formataValor(this.state.valNf)}
                    disabled={!this.props.isEditavel}
                    margin='dense'
                    id='valNf'
                    name='valNf'
                    error={this.state.errorMessageValorNf !== ''}
                    label={this.state.errorMessageValorNf !== '' ? this.state.errorMessageValorNf : 'Valor Nf'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValor}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControlValor}>
                  <TextField
                    value={this.state.valReembolso === null ? '0,00' : this.utils.formataValorNegativo(this.state.valReembolso)}
                    disabled={!this.props.isEditavel}
                    margin='dense'
                    id='valReembolso'
                    name='valReembolso'
                    error={this.state.errorMessageValorReembolso !== ''}
                    label={this.state.errorMessageValorReembolso !== '' ? this.state.errorMessageValorReembolso : 'Valor Reembolso'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValor}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControlValor}>
                  <TextField
                    value={this.state.valDeducao === null ? '0,00' : this.utils.formataValor(this.state.valDeducao)}
                    disabled={!this.props.isEditavel}
                    style={{display: 'none'}}
                    margin='dense'
                    id='valDeducao'
                    name='valDeducao'
                    label={'Valor Dedução'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValor}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
              </Paper>
              <Paper className={classes.body} elevation={1}>
                <FormControl style={{display: 'none'}}>
                  <InputLabel shrink htmlFor='tipo-simple' className={classes.selectAnoProcesso}>
                    Ano Processo
                  </InputLabel>
                  <Select
                    className={classes.selectAnoProcesso}
                    disabled={!this.props.isEditavel}
                    value={this.state.anoProcesso}
                    onChange={this.handleChangeSelectAnoProcesso}
                    inputProps={{
                      name: 'anoProcesso',
                    }}
                  >
                    <MenuItem key={0} value={0}>{''}</MenuItem>
                    {this.props.anosProcessos.map((ano, idx) => {
                      return (<MenuItem key={idx + 1} value={ano}>{ano}</MenuItem>);
                    })}
                  </Select>
                </FormControl>
                <FormControl className={classes.textFieldNumProcesso} style={{display: 'none'}}>
                  {this.state.fetchingProcessos ? <LinearProgress color='primary' />
                    : <IntegrationAutosuggest
                      disabled={this.state.anoProcesso === null || this.state.anoProcesso === undefined || this.state.anoProcesso === 0 || !this.props.isEditavel}
                      getSuggestionValue={this.getSuggestionValueNumProcesso}
                      suggestions={this.state.processos}
                      idSelected={this.state.anoProcesso === null || this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso}
                      nomeSelected={this.state.numProcesso === null || this.state.numProcesso === undefined || this.state.numProcesso === 0 ? '' : this.state.numProcesso.toString()}
                      maxSuggestions={3}
                      label={'Número Processo'} />}
                </FormControl>
                <FormControl>
                  <TextField
                    id='txtProcessoSei'
                    name='txtProcessoSei'
                    value={this.state.txtProcessoSei}
                    margin='dense'
                    fullWidth
                    style={{maxlength: '40'}}
                    disabled={!this.props.isEditavel}
                    onChange={this.handleChangeTextField}
                    className={classes.textFieldTxtCodigoSei}
                    label={'Processo SEI'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
              </Paper>
              <FormControl className={classes.formControlObservacao}>
                <TextField
                  value={this.state.txtObservacao === null ? '' : this.state.txtObservacao}
                  margin='dense'
                  disabled={!this.props.isEditavel}
                  id='txtObservacao'
                  name='txtObservacao'
                  label='Observação'
                  fullWidth
                  onChange={this.handleChangeTextField}
                  multiline
                  style={{maxlength: '1000'}}
                  rowsMax='10'
                  helperText='(max. 1.000 caracteres)'
                />
              </FormControl>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogReembolsoMedico);
